export default __webpack_public_path__ + "static/media/basicimage.bfe20742.jpg";